import { render, staticRenderFns } from "./BasicTicket.vue?vue&type=template&id=c1d0d3a0&scoped=true"
import script from "./BasicTicket.vue?vue&type=script&lang=js"
export * from "./BasicTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d0d3a0",
  null
  
)

export default component.exports